import { useSelector } from 'react-redux'

import { selectCustomerNotificationsSettings } from '@/features/domain/territory'
import { NotificationFormValues } from '@/notificationForms'

export type CompletedNotificationValues = ReturnType<typeof useCompletedNotificationValues>

/**
 * That hook grabs completedNotification values from the domain and returns them
 */
export function useCompletedNotificationValues(): NotificationFormValues {
  const notificationSettings = useSelector(selectCustomerNotificationsSettings)

  return {
    ...notificationSettings['completedSettings'],
    windowOfCommitmentToleranceMins: '30',
    notificationCutoffMins: 0,
    proximityThresholdMins: '10',
    toleranceMins: 'No',
    windowOfCommitmentSnapToMins: 0,
    alwaysNotifyAfterCutoff: false,
  }
}
